import { render } from "./cart-carousel.vue?vue&type=template&id=3763c8de&scoped=true"
import script from "./cart-carousel.vue?vue&type=script&lang=js"
export * from "./cart-carousel.vue?vue&type=script&lang=js"

import "./cart-carousel.vue?vue&type=style&index=0&id=3763c8de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3763c8de"]])

export default __exports__